import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector} from 'react-redux'
import { InputLabel, Button, TextField, Divider, Paper, GridListTileBar, CircularProgress, LinearProgress } from '@material-ui/core';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import PersonIcon from '@material-ui/icons/Person';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import { useTranslation } from 'react-i18next';

import { showAlertSnackbar } from '../../../reducers/uiSlice';
import { addCustomComplain, deleteOrderPod, getOrderPod, getRetryPod, nextTransitionSubmit, updateOrderPod } from '../../../actions/editOrderActions';
import { getOrderSignature, uploadOrderSignature, getNextTransition } from '../../../actions/editOrderActions';
import TimeoutButton from '../../Common/TimeoutButton';
import ReactImageMagnify from 'react-image-magnify';
import { DataURIToBlob, getImageDimensions, getUserPreference } from '../../../utilities/common';
import _ from 'lodash';
import Lightbox from 'react-image-lightbox';
import { operationLog } from '../../../actions/commonAction';
import FullscreenLoading from '../../Common/FullscreenLoading';

import imageCompression from 'browser-image-compression';

import UniDialog from '../../Common/UniDialog';

const useStyles = makeStyles((theme)=> ({
    oppositeContent: {
        flex: 0,
        padding:0,
    },
    photo: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
        height: '250px'
      },
    gridList: {
        flexWrap: 'nowrap',
        // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
        transform: 'translateZ(0)',
      },
    overlay: {
        zIndex: theme.zIndex.modal + 1
    }
}))

export default function FurtherOperation(props) {
    const { orderInfo } = props;    
  
    const classes = useStyles();
    const {t} = useTranslation('editOrder');    
    const dispatch = useDispatch();

    let userPref = getUserPreference();

    const NEXT_TRANSITION_STAFF_ID = 666;
    const BUTTON_UPLOAD = "BUTTON_NAME_UPLOAD";
    const BUTTON_NEXT_TRANSITION = "BUTTON_NEXT_TRANSITION";
    const BUTTON_CUSTOM_COMPLAIN = "BUTTON_CUSTOM_COMPLAIN";

    const orderSignature = useSelector(state => state.editOrder.orderSignature);
    const nextTransitionList = useSelector(state => state.editOrder.nextTransitionList) || [];

    const [photoPreviewSize, setPhotoPreviewSize] = useState({width: 250, height: 250})
    const [cloudPhotos, setCloudPhotos] = useState({});
    const [partialLoading, setPartialLoading] = useState(false);

    //used for next transition
    const [nextTransitionLocation,setNextTransitionLocation] = useState();
    const [nextTransition,setNextTransition] = useState();
    
    const [signature,setSignature] = useState();
    //const [file,setFile] = useState();
    const [isFullscreenLoading, setIsFullscreenLoading] = useState(false);

    //used for custome complain
    const [customComplain,setCustomComplain] = useState();
    const [isLightboxOpen, setIsLightboxOpen] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(0);
    const [podType, setPodType] = useState('pod'); // 0 -> signature; 1 -> retry pod

    const [operationMemo, setOperationMemo] = useState('');

    const [deletePodOpen, setDeletePodOpen] = useState(false);
    const [podInfo, setPodInfo] = useState({});

    // to prevent the contious post , once is submit , it need some time to resubmit
    const [isEditable,setIsEditable] = useState(false);
    const [isUploadSubmitted,setIsUploadSubmitted] = useState(false);
    const [isNextTransitionSubmitted,setIsNextTransitionSubmitted] = useState(false);
    const [isCustomComplainSubmitted,setIsCustomComplainSubmitted] = useState(false);
    const fileInput = React.createRef();

    const imageDiv = useRef();

    const handleDeletePodOpen = (info) => {
        setDeletePodOpen(true);
        setPodInfo(info);
    }

    const handleDeletePod = async() => {
        try {
            // The file_id is embedded in the url.
            // We have to use the work around to extract the file_id.
            const fileId = podInfo.src.replace(process.env.REACT_APP_NEW_DRIVER_SERVER_URL + '/images/', "")
            
            setIsFullscreenLoading(true);
            await dispatch(deleteOrderPod({
                order_id: orderInfo.orders.order_id,
                file_id: fileId
            }))
            await dispatch(operationLog(orderInfo.orders.order_id, userPref.username, 0, 1, 'DELETE_SIGNATURE', t('file_id') + fileId));
            dispatch(showAlertSnackbar({message: t('pod_delete_success'), type: 'success'}))
            setPartialLoading(true);
            await dispatch(getOrderPod(orderInfo.orders.order_id));
        } catch(err) {
            dispatch(showAlertSnackbar({message: t('pod_delete_fail'), type: 'error'}))
        } finally {
            setIsFullscreenLoading(false);
            setPartialLoading(false);
        }
    }

  //if the data according to the seach ID exist then assemble the data info and do some initial process
  useEffect(() => {        
    if (props.orderInfo) {
      if (props.orderInfo.orders) {
        //get the order signature
        setPartialLoading(true);
        dispatch(getOrderPod(orderInfo.orders.order_id))
        .catch((err)=>{})
        .finally(() => {
            setPartialLoading(false);
        })
        //get the order retry pod   
        let cloudPhotosClone = _.cloneDeep(cloudPhotos);
        dispatch(getRetryPod(orderInfo.orders.order_id))
        .then((res) => {
            let retryPodArr = res.reverse();
            let _retryPod = [];
            retryPodArr.map((retryGroup, indexGroup) => {
                retryGroup.map((retry, index) => {
                    _retryPod.push({
                        title: t('retry')+(retryPodArr?.length-Number(indexGroup))+'-'+(retryGroup?.length-Number(index)),
                        src: retry
                    })
                })
            })
            cloudPhotosClone['retry'] = _retryPod;
            setCloudPhotos(cloudPhotosClone);
        })
        .catch(() => {
            cloudPhotosClone['retry'] = [];
            setCloudPhotos(cloudPhotosClone);
        })

        //enable the button statue
        setIsEditable(true);
        setIsUploadSubmitted(true);
        setIsNextTransitionSubmitted(true);
        setIsCustomComplainSubmitted(true);
      }

      if (props.orderInfo.path && props.orderInfo.path.length > 0) {
          //get next order transition
          dispatch(getNextTransition(props.orderInfo.path[props.orderInfo.path.length - 1].code));
      }

    } else {
      setCloudPhotos({});
      setSignature("");
      // setFile("");
      setNextTransitionLocation("");
      setNextTransition("");
      setCustomComplain("");

      //disable the button statue
      setIsEditable(false);
      setIsUploadSubmitted(false);
      setIsNextTransitionSubmitted(false)
      setIsCustomComplainSubmitted(false);   
      setPodInfo({});       
    }

},[props.orderInfo]);

    useEffect(() => {
        (async () => {
            if(signature){
                setPhotoPreviewSize(await getImageDimensions(signature))
            } 
        })()
    }, [signature, orderSignature])

    useEffect(()=> {
        const promises = []
        const _signatures = []
        if(orderSignature?.length > 0){
            orderSignature.forEach(element => {
                promises.push(getImageDimensions(element)) 
            });
        }

        Promise.allSettled(promises)
            .then((results) => {
                results.forEach((result, index) => {
                    if(!_.isEmpty(result)){
                        if(result.status === "fulfilled"){
                            _signatures.push({
                                title: 'POD' + (Number(index) + 1),
                                src: result.value.src
                            })
                        } else {
                            console.warn(result.reason)
                        }
                    }
                })
                let cloudPhotosClone = _.cloneDeep(cloudPhotos);
                cloudPhotosClone['pod'] = _signatures;
                setCloudPhotos(cloudPhotosClone);
            })
    }, [orderSignature])

    return (
        <React.Fragment>
            <form style={{display: 'flex', flexDirection: 'row', paddingTop: 16}}>            
                <div style={{flex: 1, paddingRight: 16}}>        
                    <InputLabel style={{paddingBottom: 16}}>
                        {t('title_signature')}
                    </InputLabel>
                    <TextField
                        id="signature"
                        // autoFocus={true}
                        InputLabelProps={{ shrink: true }} 
                        placeholder="Paste your image here"
                        //disabled={true}
                        variant="outlined"
                        //signaturevalue={signature}
                        fullWidth
                        onPaste={e=>handleSignaturePaste(e)}
                    />
                    <TextField 
                        fullWidth
                        multiline
                        rows={2}
                        variant="outlined"
                        label={t('note')}
                        InputLabelProps={{ shrink: true }}
                        style={{marginTop: 20}}
                        value={operationMemo}
                        onChange={(e)=>{setOperationMemo(e.target.value)}}
                    />
                    <TimeoutButton
                        variant="contained"
                        color='secondary'
                        fullWidth
                        className={classes.button}
                        startIcon={<CloudUploadIcon />}
                        disabled={!isUploadSubmitted}
                        style={{align: "right", marginTop: 16}}
                        onClick={handleOrderSignatureUpload}
                    >                
                        {t('button_upload')}
                    </TimeoutButton>
                </div>      
                <div className={classes.photo} style={{flex: 1, paddingRight: 16}}>
                    <InputLabel style={{paddingLeft: 16, paddingBottom: 16, color: 'rgba(255, 255, 255, 1)'}}>
                        {t('title_photo_review')}
                    </InputLabel>
                    <Card >
                        {
                            signature ?
                                <ReactImageMagnify {...{
                                    smallImage: {
                                        alt: 'Photo Preview',
                                        isFluidWidth: true,
                                        src: signature || '/images/icons/image-regular.svg',
                                        sizes: "250px"
                                    },
                                    largeImage: {
                                        src: signature || '/images/icons/image-regular.svg',
                                        height: photoPreviewSize.height,
                                        width: photoPreviewSize.width
                                    },
                                    enlargedImagePosition: 'over'
                                }}/>
                                :
                                <img src='/images/icons/image-regular.svg' 
                                    style={{maxWidth: 250, maxHeight: 200, width: 'auto', height: 200}}
                                />
                        }
                    </Card>
                </div>
                <Divider orientation="vertical" flexItem />
                <div className={classes.photo} style={{flex: 2, paddingLeft: 16, paddingRight: 16}}>
                    <InputLabel style={{paddingLeft: 16, paddingBottom: 16, color: 'rgba(255, 255, 255, 1)'}}>
                        {t('title_photo')}
                    </InputLabel>
                    {
                        partialLoading ?
                        <div style={{height: 200, width: '100%', paddingTop: 100}}>
                            <LinearProgress color="secondary" />
                        </div>
                        :
                        (
                            ((orderSignature && !_.isEmpty(orderSignature)) || (cloudPhotos['retry']?.length > 0)) ?
                            <div style={{height: 200, width: '100%'}} ref={imageDiv}>
                                <GridList className={classes.gridList} cols={2.5}>
                                {_.map(cloudPhotos, (images, key) => (
                                    cloudPhotos[key]?.length > 0 &&
                                    cloudPhotos[key].map((image, index) => (
                                        <GridListTile key={`image-${key}-${index}`}>
                                            <img src={image.src} onClick={()=>openLightbox(key, index)}/>
                                            {
                                                key !== 'retry' &&
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        top: 5,　
                                                        right: 3,
                                                        zIndex: 1000,
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => handleDeletePodOpen(image)}
                                                    id="editorder-signature-deliverypod-delete-img"
                                                >
                                                    <img
                                                        src='/images/icons/closeIcon.svg'
                                                    />
                                                </div>
                                            }
                                            
                                            <GridListTileBar
                                                title={image.title}
                                            />
                                        </GridListTile>
                                    ))
                                ))}
                                </GridList>
                            </div>
                            :
                            null
                        )
                    }
                </div>
            </form>
            {isLightboxOpen && (
                <Lightbox 
                    mainSrc={cloudPhotos[podType][lightboxIndex]?.src || ""}
                    // nextSrc={cloudPhotos[(lightboxIndex + 1) % cloudPhotos.length].src}
                    // prevSrc={cloudPhotos[(lightboxIndex + cloudPhotos.length - 1) % cloudPhotos.length].src}
                    onCloseRequest={()=>setIsLightboxOpen(false)}
                    // onMovePrevRequest={() => setLightboxIndex((lightboxIndex + cloudPhotos.length - 1) % cloudPhotos.length)}
                    // onMoveNextRequest={() => setLightboxIndex((lightboxIndex + 1) % cloudPhotos.length)}
                    reactModalStyle={{overlay: {zIndex: 1400}}}
                />
            )}
            <UniDialog
                title={t('common:confirm_action')}
                message={t('confirm_to_delete_pod')+podInfo?.title+'?'}
                open={deletePodOpen}
                onClose={()=>setDeletePodOpen(false)}
                fullWidth
                onFinish={handleDeletePod}
            >
            </UniDialog>
            <FullscreenLoading open={isFullscreenLoading} />
        </React.Fragment>
    )

    function openLightbox(type, index){
        setPodType(type)
        setLightboxIndex(index)
        setIsLightboxOpen(true)
    }

    function calculateWidth(scrWidth, scrHeight, maxHeight){
        return maxHeight * (scrWidth/scrHeight) 
    }

  /**
   * order signature upload
   */
   async function handleOrderSignatureUpload() {
    let formData = null;
    let fs = null;
    try {
        setIsFullscreenLoading(true);
        formData = new FormData();
        const file = DataURIToBlob(signature)
        const options = { 
            maxSizeMB: 1,
            maxIteration: 20
        }
        let res = await imageCompression(file, options);
        fs = new File([res], 'image.jpg');
        formData.append("order_id", orderInfo.orders.order_id);
        formData.append("pod_images[]", fs);
        await dispatch(updateOrderPod(formData));
        await dispatch(operationLog(orderInfo.orders.order_id, userPref.username, 0, 1, 'UPLOAD_SIGNATURE', operationMemo));
        await dispatch(showAlertSnackbar({massage:t('upload_success'),type:'success'}));
    } catch(err) {
        if(err.status === 404) {
            dispatch(showAlertSnackbar({message: t('upload_error'), type: 'error'}));
        //     try {
        //         formData.append("order_sn", orderInfo.orders.order_sn);
        //         formData.append("signer", orderInfo.tracking.consignee);
        //         formData.append("drop_off", 1);
        //         formData.append("vcode", "KCSZ9NXanI8lT");
        //         formData.append("barcode_scanned", orderInfo.tno);
        //         formData.append("is_addon", 1);
        //         formData.append("signature", fs);
        //         await dispatch(uploadOrderSignature(formData));
        //         await dispatch(operationLog(orderInfo.orders.order_id, userPref.username, 0, 1, 'UPLOAD_SIGNATURE', operationMemo));
        //         await dispatch(showAlertSnackbar({massage:t('upload_success'),type:'success'}));
        //     } catch(e) {
        //         dispatch(showAlertSnackbar({message: e.message, type: 'error'}))
        //     } finally {}
        } else {
            dispatch(showAlertSnackbar({message: t('compress_error'), type: 'error'}));
        }
    } finally {
        setOperationMemo('');
        dispatch(getOrderPod(orderInfo.orders.order_id))
        setSignature(null);
        setIsFullscreenLoading(false);
    }
  }

  /**
   * photo review processing
   * @param {} event 
   * @returns 
   */
   function handleSignaturePaste(event) {    
    //获取截图
    let items = (event.clipboardData || window.clipboardData).items;

    let file = null;
    if (items && items.length) {
        // 搜索剪切板items
        for (let i = 0; i < items.length; i++) {
            if (items[i].type.indexOf('image') !== -1) {
                //console.log("items[i]: ",items[i]);
                file = items[i].getAsFile();
                break;
            }
        }
    } else {
        //log.innerHTML = '<span style="color:red;">当前浏览器不支持</span>';
        return;
    }
    if (!file) {
        //log.innerHTML = '<span style="color:red;">粘贴内容非图片</span>';
        return false;
    }
    //setFile(file);
    
    // 此时file就是我们的剪切板中的图片对象
    // 如果需要预览，可以执行下面代码
    let reader = new FileReader();
    reader.onload = function(event) {
        //console.log("event: ", event);
        /*var preview_html = '<img src="' + event.target.result + '" class="upload-image" style="width: 160px">';
        $("#input-area").append(preview_html);*/
        setSignature(event.target.result);
    }
    //readAsDataURL 方法用来读Blob或File内容，当读操作完成之后，readyState 状态变成DONE，并触发 loadend 方法。此时，        
    //result 属性就包含了一个URL字符串，即文件数据的base64编码格式。
    reader.readAsDataURL(file);        
    
  }    

 /**
  * submit the custom complain
  */
  function handleCustomComplainSubmit() {
    let params = {};
    let isEnable = true;
    let message = "";

    if (!orderInfo.order_id) {
        isEnable = false;
        message = ".Pls choose the order id which you want to submit!\r\n";
    }

    if (!customComplain) {
        isEnable = false;
        message += ".Pls input the complain content befor you submit!\r\n";
    }

    if (!orderInfo.shipping_staff_id) {
        isEnable = false;
        message += ".Driver which the custom want to complain haven't been decide!";
    }

    if (isEnable === false ) {
        dispatch(showAlertSnackbar({title: "Fail", message: message}));
    } else {
        preventFrequentPost(BUTTON_CUSTOM_COMPLAIN );

        params['order_id'] = Number(orderInfo.order_id);
        params['note'] = customComplain;
        params['is_complained'] = 1;
        params['driver_id'] = Number(orderInfo.shipping_staff_id);

        dispatch(addCustomComplain(params));
    }

 }

/**
 * to prevent the frequent post which may cause the unnecessary database burden, the user could only repost after 1 second
 */
function preventFrequentPost(buttonName) {

    if (buttonName === BUTTON_UPLOAD ) {
        setIsUploadSubmitted(true, 
            setTimeout(() => setIsUploadSubmitted(false), 1000)
        );        
    }

    if (buttonName === BUTTON_NEXT_TRANSITION ) {
        setIsNextTransitionSubmitted(true, 
            setTimeout(() => setIsNextTransitionSubmitted(false), 1000)
        );        
    }

    if (buttonName === BUTTON_CUSTOM_COMPLAIN ) {
        setIsCustomComplainSubmitted(true, 
            setTimeout(() => setIsCustomComplainSubmitted(false), 1000)
        );        
    }    
}

}

